import {createReducer} from '@reduxjs/toolkit'
import {Multilingual} from '../types/state'

const defaultState: Multilingual = {
  isEnabled: false,
  currentLanguage: null,
  isPrimaryLanguage: true,
}

export const multilingual = createReducer(defaultState, () => {})
